<nav class="au-navigation-panel">
  <div class="au-navigation-panel-content">
    <p-panelMenu [model]="menu" [multiple]="false"></p-panelMenu>
  </div>
</nav>
